<template>
    <div>
        <div v-if="!file">
            <b-form-file
                :accept="accept"
                :disabled="disabled"
                :loading="working"
                @input="fileChanged"
                v-model="uploadingFile"
            >
                <a class="button is-primary">
                    <upload-icon />
                    <span>{{ title }} {{ uploadingFileName }}</span>
                </a>
            </b-form-file>
        </div>

        <div class="row" v-if="file">
            <div class="col-11">
                <a
                    :href="downloadURL"
                    target="_downloadWindow"
                    v-if="!disableDownload"
                    >{{ file.original_filename }}</a
                >
                <span v-if="disableDownload">{{ file.original_filename }} </span
                >({{ file.file_size }})
            </div>
            <div class="col-1" v-if="!hideDelete">
                <b-button @click="removeFile" variant="danger">
                    <close-icon />
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
// some code from https://github.com/DoritoBandito/vuetify-upload-button/blob/master/src/UploadButton.vue
import { mapActions, mapGetters } from "vuex";

import UploadIcon from "vue-material-design-icons/Upload";
import CloseIcon from "vue-material-design-icons/Close";

export default {
    name: "OFileUpload",
    components: { UploadIcon, CloseIcon },
    model: {
        prop: "file",
        event: "change",
    },
    props: {
        file: {
            type: [Object, Array],
            default: () => {},
        },
        otherId: { type: [String, Number], default: 0 },
        otherName: { type: String, default: "default" },
        userId: { type: Number, default: null },
        dontIncludeToken: { type: Boolean, default: false },

        disableDownload: { type: Boolean, default: false },
        hideDelete: { type: Boolean, default: false },
        accept: {
            default: "",
            type: String,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        title: {
            default: "Upload",
            type: String,
        },
        uniqueId: {
            default: false,
            type: Boolean,
        },
        formState: { type: Object },
    },
    data() {
        return {
            uploadingFileName: "",
            uploadingFile: null,
        };
    },
    methods: {
        ...mapActions("FileSystemModule", ["getById", "upload", "cancel"]),

        removeFile: function () {
            this.file = null;

            if (this.formState) this.formState.dirty = true;

            this.$emit("change", null);
        },
        uploadFile: function (file) {
            this.uploadingFileName = file.original_filename;

            var data = {
                file: file,
                userId: this.userId,
                other_id: this.otherId,
                other_name: this.otherName,
            };

            var vm = this;
            this.upload(data).then(function (result) {
                if (vm.formState) vm.formState.dirty = true;
                vm.$emit("change", result);
            });
        },
        fileChanged(file) {
            if (file && !this.working) {
                this.uploadFile(file);
            } else {
                if (this.formState) this.formState.dirty = true;
                this.$emit("change", null);
            }
        },
    },
    computed: {
        ...mapGetters("AuthModule", ["token"]),
        ...mapGetters("FileSystemModule", [
            "working",
            "item",
            "progress_percentage",
        ]),

        inlineURL: function () {
            if (this.file) {
                return (
                    process.env.VUE_APP_ROOT_API +
                    "/filesystem/download/" +
                    this.file.id +
                    "/?download=true"
                );
            } else {
                return "";
            }
        },
        downloadURL: function () {
            var token = "";
            if (!this.dontIncludeToken) {
                token = "jwt=" + this.token + "&";
            }

            if (this.file) {
                return (
                    process.env.VUE_APP_ROOT_API +
                    "/filesystem/download/" +
                    this.file.id +
                    "/?" +
                    token +
                    "download=false"
                );
            } else {
                return "";
            }
        },
    },
};
</script>

<style scoped></style>
